import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ContactSupport from "../pages/contact-support/page";
import DisputeResolution from "../pages/dispute-resolution/page";
import CancellingPage from "../pages/subscription/CancellingPage";
import AutoRenewPage from "../pages/subscription/AutoRenewPage";
import NoProductPage from "../pages/subscription/NoProductPage";
import RefundPage from "../pages/billing/RefundPage";
import UnrecognizedChargePage from "../pages/billing/UnrecognizedChargePage";
import UnawareChargesPage from "../pages/billing/UnawareChargesPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/contact-support",
    element: <ContactSupport />,
  },
  {
    path: "/dispute-resolution",
    element: <DisputeResolution />,
  },
  {
    path: "/subscription/cancelling",
    element: <CancellingPage />,
  },
  {
    path: "/subscription/auto-renew",
    element: <AutoRenewPage />,
  },
  {
    path: "/subscription/no-product",
    element: <NoProductPage />,
  },
  {
    path: "/billing/refund",
    element: <RefundPage />,
  },
  {
    path: "/billing/unrecognized-charge",
    element: <UnrecognizedChargePage />,
  },
  {
    path: "/billing/unaware-charges",
    element: <UnawareChargesPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
